import { queryString } from '@shared/hooks/recoil-query';
import { api_ } from '@shared/plugIn/axios';
import { LowerRole } from '@shared/types';

import {
  GiftItemBrand,
  GiftItemBrandCreate,
  GiftItemBrandUpdate,
} from './giftItemBrand.interface';

// 목록 조회
// - admin/GiftAgent(admin): 전체 브랜드
// - gift-brand-seller: 백엔드 owningFilter로 본인 브랜드 1건만 반환
export const listGiftItemBrand = async (
  role: LowerRole,
): Promise<GiftItemBrand[]> => {
  const res = await api_.get(
    `/${role}/gift-item-brand?${queryString({ options: { sort: { name: 1 } } })}`,
  );
  return res.data;
};

// 생성
export const createGiftItemBrand = async (
  data: GiftItemBrandCreate,
  role: LowerRole,
): Promise<GiftItemBrand> => {
  const res = await api_.post(`/${role}/gift-item-brand`, data);
  return res.data;
};

// 수정
export const updateGiftItemBrand = async (
  id: string,
  data: GiftItemBrandUpdate,
  role: LowerRole,
): Promise<GiftItemBrand> => {
  const res = await api_.patch(`/${role}/gift-item-brand/${id}`, data);
  return res.data;
};

// 삭제
export const deleteGiftItemBrand = async (id: string, role: LowerRole): Promise<void> => {
  await api_.delete(`/${role}/gift-item-brand/${id}`);
};
